import { Box, Button, styled } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { ICONS, IconFixedSize, unit } from '@hcr/ui'

import { COLORS } from '../../../../../../../../../libs/ui/src/lib/constants'
import { Drawer } from '../../../../drawer'

type NavigationMenuDrawerProps = PropsWithChildren & { isVisble: boolean; setIsVisble: (isVisble: boolean) => void }

export const NavigationMenuDrawer: FC<NavigationMenuDrawerProps> = ({ children, setIsVisble, isVisble }) => {
  const { t } = useTranslation()

  return (
    <StyledDrawer
      paddingLeft={unit(3.5)}
      paddingRight={unit(3.5)}
      paddingBottom={unit(4)}
      paddingTop={unit(4)}
      onClose={() => setIsVisble(false)}
      disablePortal={true}
      slotProps={{
        backdrop: {
          sx: {
            opacity: '0.2 !important',
          },
        },
      }}
      PaperProps={{
        sx: theme => ({
          backgroundColor: COLORS.vaalea[400],
          width: unit(93.75),
          padding: 0,
          top: unit(18),
          left: 'auto',
          height: 'auto',

          [theme.breakpoints.down('lg')]: {
            '& .MuiDrawer-paper': {
              position: 'absolute',
              boxSizing: 'border-box',
            },
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            '& > div': {
              flexGrow: 1,
              height: 'auto',
            },
          },
          [theme.breakpoints.up('lg')]: {
            right: unit(8.5),
          },
          [theme.breakpoints.up('xl')]: {
            right: unit(36),
          },
        }),
      }}
      open={isVisble}
    >
      <DialogBox role='dialog' aria-modal='true' aria-labelledby='modal-title'>
        <CloseButtonRow>
          <Button
            sx={{
              height: unit(11),
              width: unit(11),
              minWidth: 'unset',
              padding: 0,
              '&:hover': {
                backgroundColor: 'inherit',
                boxShadow: 'none',
              },
            }}
            onClick={() => setIsVisble(false)}
            aria-label={t('navigation.close-menu')}
          >
            <Icon icon={ICONS.farXmark} aria-hidden={true} />
          </Button>
        </CloseButtonRow>
        {children}
      </DialogBox>
    </StyledDrawer>
  )
}

const Icon = styled(IconFixedSize)`
  color: ${COLORS.black};
  text-align: center;
`

const StyledDrawer = styled(Drawer)`
  position: absolute;

  & .MuiDrawer-paper {
    position: absolute;
    box-sizing: border-box;
  }
`

const DialogBox = styled(Box)`
  flex-grow: 1;
  background-color: ${COLORS.vaalea['60%']};

  ${({ theme }) => theme.breakpoints.down('lg')} {
    width: 100%;
    height: 100%;
    top: 0;
    overflow-wrap: break-word;
    word-break: break-word;
  }
`

const CloseButtonRow = styled(Box)`
  display: flex;
  justify-content: end;
  align-items: center;
  padding-top: ${unit(2.5)};
  padding-right: ${unit(2)};
`
